import React from 'react';
import {
  Box, createStyles, Title, Text, Grid,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';

const useStyles = createStyles((theme) => ({
  generalBox: {
    marginBlock: theme.spacing.sm,
    padding: theme.spacing.sm,
  },
  detailsBox: {
    margin: theme.spacing.sm,
  },
  title: {
  },
  description: {
    paddingBottom: theme.spacing.sm,
  },
}));

interface AbilitiesEntriesProps {
  title: string,
  description: string,
}
export function AbilitiesEntry({ title, description }: AbilitiesEntriesProps) {
  const { classes } = useStyles();

  return (
    <>
      <Title className={classes.title} order={3}>{title}</Title>
      <Text className={classes.description} size="md">{description}</Text>
    </>
  );
}

export default function Abilities() {
  const { classes } = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'abilities' });

  const items = t('content', {
    returnObjects: true,
    defaultValue: [],
  }) as { title: string; description: string }[];

  return (
    <Box className={classes.generalBox}>
      <Grid>
        {items.map((item) => (
          <Grid.Col span={12} key={item.title}>
            <AbilitiesEntry
              title={item.title}
              description={item.description}
            />
          </Grid.Col>
        ))}
      </Grid>
    </Box>
  );
}
